












import { Component, Prop, Vue } from "vue-property-decorator";

const LISTA = [
  "Está tendo dificuldade de relacionamento com seus filhos adolescentes?",
  "Tem evitado o contato ou o convívio com possível namorado(a) por achar que não consegue entender os relacionamentos?",
  "Não consegue manter um diálogo com seu namorado ou marido de forma sadia?",
  "Não entende a relação conturbada que está vivendo, mas acredita que é possível melhorar a convivência com seus irmãos, pais ou namorado(a)?",
  "Tem enfrentado dificuldade para educar e criar seus filhos que têm idades diferentes?",
  "Já tentou de tudo e está muito próximo de se separar?"
];

@Component
export default class extends Vue {
  // @Prop() private msg!: string;
  itens: Array<Item> = [];

  // Lifecycle hook
  mounted() {
    let counter = 0;
    this.itens = LISTA.map(function(item) {
      counter++;
      return new Item(counter, item);
    });
  }
}

class Item {
  numero: number;
  nome: string;
  constructor(numero: number, nome: string) {
    this.numero = numero;
    this.nome = nome;
  }
}
